module.exports = __webpack_public_path__ + "static/img/hangzhoumajiang.526f93e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/hangzhoumajiang.jpg
// module id = 1vqm
// module chunks = 0